import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const query = useQuery();

  const type = query.get('type');
  const reference = query.get('reference');
  const paymentId = query.get('payment_id');
  const recurringBillingId = query.get('recurring_billing_id');
  const status = (query.get('status') || '').toLowerCase();

  const isSuccess = status === 'active' || status === 'completed' || status === 'succeeded' || status === 'success';

  useEffect(() => {
    // Optional: auto-redirect to dashboard on success after short delay
    // Uncomment if desired
    // if (isSuccess) {
    //   const t = setTimeout(() => navigate('/subscription/dashboard'), 1500);
    //   return () => clearTimeout(t);
    // }
  }, [isSuccess, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-xl w-full bg-white shadow-md rounded-lg p-6 text-center">
        {isSuccess ? (
          <>
            <div className="mx-auto mb-4 h-14 w-14 rounded-full bg-green-100 flex items-center justify-center">
              <span className="text-green-600 text-2xl">✓</span>
            </div>
            <h1 className="text-2xl font-semibold text-gray-900">Subscription successful</h1>
            <p className="mt-2 text-gray-600">Your subscription payment was processed successfully.</p>
          </>
        ) : (
          <>
            <div className="mx-auto mb-4 h-14 w-14 rounded-full bg-red-100 flex items-center justify-center">
              <span className="text-red-600 text-2xl">!</span>
            </div>
            <h1 className="text-2xl font-semibold text-gray-900">Payment status: {status || 'unknown'}</h1>
            <p className="mt-2 text-gray-600">We couldn't verify a successful payment. If you were charged, your subscription will activate shortly.</p>
          </>
        )}

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
          <button
            onClick={() => navigate('/subscription/dashboard')}
            className="w-full inline-flex items-center justify-center rounded-md bg-orange-600 px-4 py-2.5 text-sm font-medium text-white shadow hover:bg-orange-700 focus:outline-none"
          >
            Go to Subscription Dashboard
          </button>
          <button
            onClick={() => navigate('/properties')}
            className="w-full inline-flex items-center justify-center rounded-md bg-white px-4 py-2.5 text-sm font-medium text-gray-700 ring-1 ring-inset ring-gray-200 hover:bg-gray-50"
          >
            Manage My Properties
          </button>
        </div>

        <div className="mt-6 text-left text-xs text-gray-500">
          <div>Details</div>
          <ul className="mt-1 space-y-1">
            {type && <li><b>Type:</b> {type}</li>}
            {status && <li><b>Status:</b> {status}</li>}
            {reference && <li><b>Reference:</b> {reference}</li>}
            {paymentId && <li><b>Payment ID:</b> {paymentId}</li>}
            {recurringBillingId && <li><b>Recurring Billing ID:</b> {recurringBillingId}</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
